// extracted by mini-css-extract-plugin
module.exports = {"card":"ComparativeCard_card__3FNpJ","main":"ComparativeCard_main__1RNVZ","secondary":"ComparativeCard_secondary__24uTR","tenant-prospect":"ComparativeCard_tenant-prospect__3ZKC9"};